import { r as registerInstance, h, H as Host } from './index-5faac9d7.js';
import { t as tryParse } from './index-e29b327a.js';
import { B as Brand } from './types-66e6568b.js';
import './currency-7be6806c.js';
import './lodash-bd96d09c.js';
import './_commonjsHelpers-11ca3be1.js';
import './analytics-205f1857.js';
import './_nodeUtil-f95b2b52.js';
import './_Stack-68736bd1.js';

const sePesComparisonPdfCss = ":host{display:block}";

const ApcPesComparisonPdf = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this._comparatorLabels = undefined;
    this._comparatorCharacteristics = undefined;
    this._comparatorPriceInfo = undefined;
    this.comparatorLabels = undefined;
    this.comparatorCharacteristics = undefined;
    this.comparatorPriceInfo = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c;
    this.comparatorLabels = (_a = tryParse(this._comparatorLabels)) !== null && _a !== void 0 ? _a : this.comparatorLabels;
    this.comparatorCharacteristics = (_b = tryParse(this._comparatorCharacteristics)) !== null && _b !== void 0 ? _b : this.comparatorCharacteristics;
    this.comparatorPriceInfo = (_c = tryParse(this._comparatorPriceInfo)) !== null && _c !== void 0 ? _c : this.comparatorPriceInfo;
  }
  render() {
    return (h(Host, null, h("pes-comparison-pdf", { comparatorLabels: this.comparatorLabels, comparatorCharacteristics: this.comparatorCharacteristics, comparatorPriceInfo: this.comparatorPriceInfo, brand: Brand.se })));
  }
};
ApcPesComparisonPdf.style = sePesComparisonPdfCss;

export { ApcPesComparisonPdf as se_pes_comparison_pdf };
